var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container min-vh-100 d-flex align-middle justify-content-center"},[_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }